import { Injectable } from '@angular/core';

import { filter } from 'rxjs';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { selectChatState, selectUiState, selectUser } from '../../../store/app.selectors';

import { LoggerService } from '../../../core/services/logger.service';
import { SnackBarService } from '../../../core/services/snackbar.service';
import { IUserProfile } from '../../user/interfaces/IUserProfile';
import { IChannel, IChannelFilter } from '../interfaces/IChannel';
import { IMessageableEntity } from '../interfaces/IMessageableEntity';
import { IWorkspace } from '../interfaces/IWorkspace';
import { ChannelsService } from '../services/channels.service';
import { MessagesService } from '../services/messages.service';
import { MessagingApiService } from '../services/messaging-api/messaging-api.service';
import { PermissionsService } from '../services/permissions.service';
import { AppStateWithChat } from './chat.reducer';

@Injectable()
export abstract class ChatEffectsBase {
  selectedChannel: IChannel | null;
  selectedWorkSpace: IWorkspace | null;
  user: IUserProfile | null;
  scrollPosition: number;
  messagesFilter: { size: number };
  channelsFilter: IChannelFilter;
  channels: IChannel[];
  users: IMessageableEntity[];

  constructor(
    protected actions$: Actions,
    protected store: Store<AppStateWithChat>,
    protected messagingApiService: MessagingApiService,
    protected snackBarService: SnackBarService,
    protected channelsService: ChannelsService,
    protected messagesService: MessagesService,
    protected permissionsService: PermissionsService,
    protected logger: LoggerService
  ) {
    this.setChatSubscription();
    this.setUserSubscription();
    this.setUiSubscription();
  }

  private setChatSubscription(): void {
    this.store
      .select(selectChatState)
      .pipe(filter((data) => data !== undefined))
      .subscribe(({ selectedWorkSpace, channelsFilter, users, channels, selectedChannel, messagesFilter }) => {
        this.selectedWorkSpace = selectedWorkSpace;
        this.messagesFilter = messagesFilter;
        this.selectedChannel = selectedChannel;
        this.channelsFilter = channelsFilter;
        this.channels = channels;
        this.users = users;
      });
  }

  private setUserSubscription(): void {
    this.store.select(selectUser).subscribe((user) => {
      this.user = user;
    });
  }

  private setUiSubscription(): void {
    this.store.select(selectUiState).subscribe(({ scrollPosition }) => {
      this.scrollPosition = scrollPosition;
    });
  }
}
